import { notifyAlert } from 'notifications';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';

const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    notifyAlert('Something went wrong, please reload the page!');
  }

  return next(action);
};

export default rtkQueryErrorLogger;
